import { generateDefaultSelectors } from "@/redux/selectors.utils";
import { IState } from "@/redux/store.types";
import { getApiDataState } from "@/redux/utils";

import { $StoreDetailsModuleName } from "./storeDetails.types";

const { isLoading } = generateDefaultSelectors($StoreDetailsModuleName);

const getStoreDetails = (state: IState) => {
    const storeDetailsState = getApiDataState(state, $StoreDetailsModuleName);
    return storeDetailsState?.data;
};

export { getStoreDetails, isLoading };
